const Card = ({ title, value }) => (
  <div className="bg-white rounded-xl shadow p-5">
    <p className="text-sm text-gray-500">{title}</p>
    <h2 className="text-3xl font-bold mt-2">
      {Number(value || 0).toLocaleString()}
    </h2>
  </div>
);

export default function SummaryCards({ summary, activeTab }) {
  const data = summary?.[0] || {};

  const cards = {
    contest: [
      { title: "Contest Spent", value: Math.abs(data.contestSpent) },
      { title: "Contest Earned", value: data.contestEarned },
    ],

    question: [
      { title: "Question Spent", value: Math.abs(data.questionSpent) },
      { title: "Question Earned", value: data.questionEarned },
    ],

    recharge: [
      { title: "Recharge", value: data.recharge },
    ],

    referral: [
      { title: "Referral", value: data.referral },
    ],

    refund: [
      { title: "Refund", value: data.refund },
    ],

    // plan: [
    //   { title: "Plan Purchase", value: Math.abs(data.planPurchase) },
    // ],

    withdrawal: [
      { title: "Withdrawal", value: Math.abs(data.withdrawal) },
    ],

    all: [
      { title: "Contest Spent", value: Math.abs(data.contestSpent) },
      { title: "Contest Earned", value: data.contestEarned },
      { title: "Question Spent", value: Math.abs(data.questionSpent) },
      { title: "Question Earned", value: data.questionEarned },
      { title: "Recharge", value: data.recharge },
      { title: "Referral", value: data.referral },
      { title: "Refund", value: data.refund },
    //   { title: "Plan Purchase", value: Math.abs(data.planPurchase) },
      { title: "Withdrawal", value: Math.abs(data.withdrawal) },
      { title: "Transactions", value: data.totalTransactions },
    ],
  };

  const visibleCards = cards[activeTab] || cards.all;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {visibleCards.map((card) => (
        <Card
          key={card.title}
          title={card.title}
          value={card.value}
        />
      ))}
    </div>
  );
}